import Cookies from "js-cookie";

export const baseUrl = process.env.REACT_APP_API + "/api";
export const webSocketUrl = process.env.REACT_APP_API;

export const getAuthHeader = () => {
  const token = Cookies.get("AUTH_TOKEN");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// auth
export const LOGIN_URL = baseUrl + "/auth/login";
export const LOGIN_OTP_URL = baseUrl + "/otp/verify-otp";
export const LOGOUT_URL = baseUrl + "/auth/logout";
export const SIGNUP_URL = baseUrl + "/auth/signup";
export const FORGET_PASSWORD_URL = baseUrl + "/auth/forget-password";
export const RESET_PASSWORD_URL = baseUrl + "/auth/reset-password";

export const IOT_GATEWAY_SERVICE_URL = baseUrl + "/iot-gateway";
export const ORGANIZATION_URL = baseUrl + "/firm";
export const MACHINE_URL = baseUrl + "/assets";
export const USER_URL = baseUrl + "/users";
export const ROLE_URL = baseUrl + "/roles";
export const USER_ACCESS_URL = baseUrl + "/role-menu-access";

export const MQTT_URL = baseUrl + "/mqtt";
export const PRODUCT_URL = baseUrl + "/products";
